module.exports = __webpack_public_path__ + "static/media/dungeon_floor_w.7e1eda0e.png";